export default __webpack_public_path__ + "static/media/gundam-logo.bb22e19a.webp";